import { combineReducers } from "@reduxjs/toolkit";
import { ImageSliceReducer, CanvasSliceReducer } from "@VinciDiane/canvas-engine";
import FileReducer from "./features/PDF/FileSlice";
import ComptageReducer from "./features/Comptage";
import IEPReducer from "./features/IEP";

// Clés lues par les packages @VinciDiane/* publiés (state.file, state.IEP, state.Comptage, state.image, state.canvas).
const rootReducer = combineReducers({
  file: FileReducer,
  IEP: IEPReducer,
  Comptage: ComptageReducer,
  image: ImageSliceReducer,
  canvas: CanvasSliceReducer,
});

export default rootReducer;
